import NpsByAnswerToOtherQuestionWidget from './NpsByAnswerToOtherQuestionWidget';
export default NpsByAnswerToOtherQuestionWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/NpsByAnswerToOtherQuestionWidget/index.js